// extracted by mini-css-extract-plugin
module.exports = {"Small":"style_Small__2ZB4j","Medium":"style_Medium__18jW7","Large":"style_Large__3tKIH"};